require('intersection-observer');


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

/*
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {}
*/
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

axios.defaults.baseURL = process.env.MIX_APP_URL;

axios.interceptors.request.use(
    (config) => {
        config.headers.common['Content-Type'] = 'application/json';
        config.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        config.headers.common['referrer'] = document.referrer;


        if (!config.headers.Authorization) {
            const switchToken = localStorage.getItem('switch_token');
            const token = localStorage.getItem('loggedin_access_token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            if (switchToken !== null) {
                config.headers = { ...config.headers, ...{ 'Switch-Token': switchToken } };
            }
        }


        return config;
    },
    (error) => Promise.reject(error),
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        console.error('interceptors: ', error);

        if (error.message && error.message.includes('Network error')) {
            alert('Please check your internet connection and try again');
            return;
        }

        const userInformation = JSON.parse(localStorage.getItem('user'));
        if (error.response && error.response.status === 401 && userInformation) {
            const exclude = ['login', 'test'];
            const pageURL = window.location.href;
            const lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);

            localStorage.clear();

            if (!exclude.includes(lastURLSegment)) {
                window.location = '/login';
            }
        }

        return Promise.reject(error);
    },
);

Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
};

(() => {
    const darkmode = localStorage.getItem('darkmode');
    const isDarkmode = darkmode ? JSON.parse(darkmode) : false;
    const loginUser = localStorage.getItem('loggedin_user');

    if (loginUser && isDarkmode) {
        document.body.classList.add('darkmode');
    }
})();

if (process.env.NODE_ENV === 'production') {
    const params = new URLSearchParams(window.location.search);
    const isDebug = params.get('debug');
    if (!isDebug) {
        console.log = () => { };
        console.error = () => { };
        console.debug = () => { };
    }
}
